module.exports = __webpack_public_path__ + "img/member01.267c394c.png";